export default "__VITE_ASSET__b22dcae2__"